import { usePsvScreensGate } from 'hooks/usePsvScreensGate';

export function usePsvScreensEnabled(asset) {
    return usePsvScreensGate(asset).enabled;
}
